import { Project, ProjectFlowchart, ProjectStatsConfiguration } from './../../../interfaces/project';
import { Component, Input } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ProjectService } from './../../../services/project.service';
import { DateRange } from './../../../interfaces/dateRange';
import { LocalStorageService } from 'angular-2-local-storage';
import { ActivatedRoute } from '@angular/router';
import { ChecklistItem } from '../../../interfaces/checklistItem';

@Component({
	selector: 'library-project-details-flowchart',
	templateUrl: './library-project-details-flowchart.component.html',
	styleUrls: ['./library-project-details-flowchart.component.scss']
})


export class LibraryProjectDetailsFlowchartComponent {

	@Input() project: Project;
	@Input() form: NgForm;
	@Input() statsMode: boolean;
	@Input() checklistItems: ChecklistItem[];

	projectSubscription: Subscription;
	firstStep: any;
	flowchart: ProjectFlowchart;
	configuration: ProjectStatsConfiguration;
	projectStatsDates: string;
	projectId: string;
	projectDownloadUrl: string;

	constructor(private route: ActivatedRoute, private projectService: ProjectService, private localStorageService: LocalStorageService) {
		this.projectId = this.route.snapshot.paramMap.get('id');
		this.projectSubscription = this.projectService.get(this.projectId).subscribe((project: Project) => {
			// console.log('GET PROJECT - project stats', project);
			this.projectDownloadUrl = this.projectService.projectDownloadUrl + project.id;
			this.project = project;
			this.firstStep = null;
			if (project) {
				if (project && project.clipCount === 1 && this.project.chapters) {
					for ( const chapterIndex in this.project.chapters) {
						if (chapterIndex) {
							for ( const step in this.project.chapters[chapterIndex].steps ) {
								if (!this.firstStep) {
									this.firstStep = this.project.chapters[chapterIndex].steps[step];
								}
							}
						}
					}
					if (this.firstStep && !this.firstStep.entityId) {
						this.firstStep = null;
					}
				} else {
					if (this.project.subtype !== 'simple') {
						this.flowchart = this.project.flowchart;
					}
				}
			}
		});
		this.loadConfig();
	}

	datesChanged(dateRange: DateRange) {
		this.configuration.statsDateStart = dateRange.startDate;
		this.configuration.statsDateEnd = dateRange.endDate;
		this.storeConfig();
		this.projectService.getProjectStats(dateRange);
		this.projectStatsDates = this.projectService.getStatsQueryParamsString();
	}

	loadConfig() {
		const configJson = this.localStorageService.get('project_stats_config');

		let config;

		if (configJson) {
			config = JSON.parse(configJson as string);
		} else {
			// defaults
			config = {
				showEngagement: true,
				showKpis: true,
				showNavigation: false
			};
		}

		this.configuration = config as ProjectStatsConfiguration;
	}

	storeConfig() {

		// convert Dates to strings before saving json
		const config = { ... this.configuration } as any; // copy

		// we only store the dates for custom periods

		if (config.statsDatePreset === 'custom') {
			config.statsDateStart = this.configuration.statsDateStart.toString();
			config.statsDateEnd = this.configuration.statsDateEnd.toString();
		} else {
			delete config.statsDateStart;
			delete config.statsDateEnd;
		}

		this.localStorageService.set('project_stats_config', JSON.stringify(config));
	}

	downloadFormData() {
		this.projectService.downloadFormData();
	}

	rebuildFlowchart() {
		this.projectService.rebuildFlowchart();
	}
}
